import { entryContextFromLocation, type SurfaceSignal } from '../domain/events';

/**
 * 표면 신호 전송기.
 *
 * 설계 원칙 세 가지 — 다른 제품에서 실측된 실패를 그대로 막는다.
 *
 * 1. **빌드 환경변수에 걸지 않는다.** 전송 주소는 같은 오리진의 상대 경로다.
 *    `if (apiBase)` 같은 가드 뒤에 두면 그 값이 없는 빌드에서 리스너 자체가
 *    등록되지 않고, 코드 리뷰로는 완벽해 보인다.
 * 2. **`sendBeacon`을 쓰지 않는다.** 자격 증명을 포함해 보내므로 preflight가
 *    `Access-Control-Allow-Credentials`를 요구하고, 없으면 브라우저가 전부 막는다.
 *    계측에 쿠키를 실을 이유가 없다.
 * 3. **진입 즉시 1회.** 특정 화면·특정 상태에서만 발화하면 랜딩만 보고 떠난
 *    방문자가 통째로 빠져 활성화율이 "등록한 사람 중 활성화율"이 된다.
 *
 * 전송 실패는 언제나 삼킨다. 계측 실패가 제품 동작을 막으면 안 된다.
 */
const ENDPOINT = '/api/events';

/** 같은 페이지 로드에서 같은 신호를 두 번 보내지 않는다. 저장소를 쓰지 않는다. */
const sent = new Set<SurfaceSignal>();

export function trackSurface(signal: SurfaceSignal, detail: { decided?: boolean; presetId?: string } = {}): void {
  if (typeof window === 'undefined' || typeof fetch !== 'function') return;
  if (!navigator.onLine) return;
  if (sent.has(signal)) return;
  sent.add(signal);
  try {
    void fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        name: signal,
        ...detail,
        productId: 'audition-take-preflight',
        occurredAt: new Date().toISOString(),
        entry: entryContextFromLocation(window.location.pathname, window.location.search, document.referrer, window.location.origin),
      }),
      credentials: 'omit',
      // 이탈 직전 전송이 브라우저에 죽지 않게 한다. 이탈률이 가장 높은 첫 몇 초
      // cohort가 빠지면 퍼널 앞단이 통째로 사라진다.
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // 삼킨다.
  }
}

export function observeReturn(storage:Pick<Storage,'getItem'|'setItem'>=localStorage,at=Date.now()):boolean {
 const day=new Date(at).toISOString().slice(0,10);const first=storage.getItem('atp:first-seen');
 if(!first||!Number.isFinite(Number(first))){storage.setItem('atp:first-seen',String(at));return false;}
 if(at-Number(first)>=7*86400000&&storage.getItem('atp:last-revisit')!==day){storage.setItem('atp:last-revisit',day);return true;}
 return false;
}
try { if(typeof window!=='undefined'&&typeof localStorage!=='undefined'&&observeReturn())trackSurface('revisit_7d'); } catch { /* Blocked storage never prevents use. */ }
